import React, { useState } from "react";

export const ACCOUNT_DELETION_REASON_KEYS = [
  "setup_unclear",
  "expected_something_else",
  "no_family_invite",
  "privacy_concern",
  "too_many_steps",
  "technical_problem",
  "missing_feature",
  "just_testing",
  "not_ready",
  "other",
  "prefer_not_to_say",
];

export default function AccountDeletionSurvey({
  t,
  reasons,
  setReasons,
  otherText,
  setOtherText,
  onContinue,
  onCancel,
}) {
  const [error, setError] = useState("");

  const toggleReason = (reason) => {
    setError("");
    if (reason === "prefer_not_to_say") {
      setReasons(reasons.includes(reason) ? [] : [reason]);
      setOtherText("");
      return;
    }
    const withoutExclusive = reasons.filter((item) => item !== "prefer_not_to_say");
    if (withoutExclusive.includes(reason)) {
      setReasons(withoutExclusive.filter((item) => item !== reason));
      if (reason === "other") setOtherText("");
      return;
    }
    if (withoutExclusive.length >= 5) {
      setError(t("accountDeletionSurvey.maxReasons"));
      return;
    }
    setReasons([...withoutExclusive, reason]);
  };

  const continueToVerification = () => {
    if (!reasons.length) {
      setError(t("accountDeletionSurvey.required"));
      return;
    }
    if (reasons.includes("other") && !String(otherText || "").trim()) {
      setError(t("accountDeletionSurvey.otherRequired"));
      return;
    }
    setError("");
    onContinue();
  };

  return (
    <section className="accountDeletionSurvey" aria-labelledby="account-deletion-survey-title">
      <div className="accountDeletionSurveyHeading">
        <span aria-hidden="true">◫</span>
        <h4 id="account-deletion-survey-title">{t("accountDeletionSurvey.title")}</h4>
      </div>
      <div className="accountDeletionSurveyOptions">
        {ACCOUNT_DELETION_REASON_KEYS.map((reason) => {
          const selected = reasons.includes(reason);
          return (
            <button
              type="button"
              key={reason}
              className={`accountDeletionSurveyOption${selected ? " isSelected" : ""}`}
              aria-pressed={selected}
              onClick={() => toggleReason(reason)}
            >
              <span className="accountDeletionSurveyCheck" aria-hidden="true">{selected ? "✓" : ""}</span>
              <span>{t(`accountDeletionSurvey.reason.${reason}`)}</span>
            </button>
          );
        })}
      </div>
      {reasons.includes("other") && (
        <textarea
          className="input fullInput accountDeletionSurveyOther"
          value={otherText}
          maxLength={500}
          onChange={(event) => setOtherText(event.target.value)}
          placeholder={t("accountDeletionSurvey.otherPlaceholder")}
          aria-label={t("accountDeletionSurvey.otherPlaceholder")}
        />
      )}
      {error && <div className="accountDeletionSurveyError" role="alert">{error}</div>}
      <div className="familyDeleteAccountActions">
        <button type="button" className="familyDeleteAccountButton" onClick={continueToVerification}>
          {t("accountDeletionSurvey.continue")}
        </button>
        <button type="button" className="secondaryButton" onClick={onCancel}>{t("common.cancel")}</button>
      </div>
    </section>
  );
}
